import { useEffect, useState } from "react";
import { GEO_POSITION_OPTIONS, isGeolocationSecureContext } from "@/lib/geolocation";

const STORAGE_KEY = "matpass_home_geo";

function readStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (Number.isFinite(parsed?.lat) && Number.isFinite(parsed?.lng)) {
      return { lat: parsed.lat, lng: parsed.lng };
    }
  } catch {}
  return null;
}

/**
 * Best-effort home-page geolocation (silent — no toasts).
 * Caches in sessionStorage for the browser tab.
 */
export function useHomeGeo() {
  const [coords, setCoords] = useState(readStored);
  const [ready, setReady] = useState(() => !!readStored());

  useEffect(() => {
    if (coords) {
      setReady(true);
      return;
    }
    if (typeof navigator === "undefined" || !navigator.geolocation || !isGeolocationSecureContext()) {
      setReady(true);
      return;
    }

    let cancelled = false;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        if (cancelled) return;
        const next = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        setCoords(next);
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        } catch {}
        setReady(true);
      },
      () => {
        if (!cancelled) setReady(true);
      },
      GEO_POSITION_OPTIONS,
    );

    return () => {
      cancelled = true;
    };
  }, [coords]);

  return { coords, ready };
}
